import { getElSize } from '@/scripts/tools/utilities'

document.addEventListener('alpine:init', () => {
  Alpine.store('sizes', {
    header: {
      size: 0,
      observer: null,
      selector: '[data-ref="header"]',
      cssVariable: '--header-height',
    },

    init() {
      this.initAllObservers()
      this.observeAll()
    },

    initAllObservers() {
      this.initObserver('header')
    },

    observeAll() {
      this.observe('header')
    },

    initObserver(componentName, propertyToWatch = 'height') {
      this[componentName].observer = new ResizeObserver(() => {
        const sizeValue = getElSize(this[componentName].selector, propertyToWatch)
        this.setComponentSize(componentName, sizeValue)
      })
    },

    observe(componentName) {
      const el = document.querySelector(this[componentName].selector)
      if (el) this[componentName].observer.observe(el)
      else this.setComponentSize(componentName, 0)
    },

    setComponentSize(componentName, sizeValue) {
      this[componentName].size = sizeValue
      this.setCssVariable(this[componentName].cssVariable, sizeValue)
    },

    setCssVariable(name, value) {
      document.documentElement.style.setProperty(name, `${value}px`)
    },
  })
})
